import React from 'react';
import "./Footer.css";
import payment_image from "../../../assets/img/icon/payments-2.png";

const Footer = () => {
  return (
    <footer className="footer-area footer-1 black-bg pt-100  gray-bg-2 pb-80">
        <div className="container">
            <div className="row">
                <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6">
                    <div className="widget f-widget pb-30 wow fadeInUp" data-wow-delay=".4s">
                        <h5 className="f-widget-title white-color">Information</h5>
                        <ul>
                            <li><a href="/shop">Shop</a></li>
                            <li><a href="/About">About Us</a></li>
                            <li><a href="/Login">Login</a></li>
                            <li><a href="/SignUp">Register</a></li>
                        </ul>
                    </div>
                </div>
                <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6">
                    <div className="widget f-widget pb-30 wow fadeInUp" data-wow-delay=".6s">
                        <h5 className="f-widget-title white-color">Our Service</h5>
                        <ul>
                            
                            <li><a href="/TermsConditions">Terms & Conditions</a></li>
                            <li><a href="/ReturnsRefunds">Returns & Refunds</a></li>
                            <li><a href="/Contact">Contact Us</a></li>
                        </ul>
                    </div>
                </div>
                <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6">
                    <div className="widget f-widget pb-30  wow fadeInUp" data-wow-delay=".8s">
                        <h5 className="f-widget-title white-color">Payment & Shipping</h5>
                        <ul>
                            <li><a href="/PrivacyPolicy">Privacy Policy</a></li>
                            <li><a href="/ShippingPolicy">Shipping Policy</a></li>
                            <li><a href="/Faq">FAQs</a></li>
                        </ul>
                    </div>
                </div>
                {/*
                <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6">
                    <div className="widget f-widget pb-30 wow fadeInUp" data-wow-delay="1s">
                        <h5 className="f-widget-title white-color">LOOKING FOR BRAVE Athleisure?</h5>
                        <address>
                            <ul>
                                <li>Road-2830, Block-428, Building-2304,</li>
                                <li>Office-71, 72, Seef, BAHRAIN</li>
                                <li>(+973) 1700 0038</li>
                                <li><a href="mailto:customerservices@braveathleisure.com">customerservices@braveathleisure.com</a></li>
                            </ul>
                        </address>
                    </div>
                </div>
                */}
            </div>
        </div>
        <div className="copyright-area">
            <div className="copyright-text copyright-text-3 text-center pt-20">
                <div className="container">
                    <p>{/* Working Hours: Sat-Thu: <span>9:00 am – 6:00 pm.</span>
                    <br/> */}
                        Copyright © 2026 BRAVE Athleisure Store all rights reserved. Powered by BRAVE Athleisure</p>
                    <img src={payment_image} alt="img" />
                </div>
            </div>
        </div>
    </footer>
  )
}

export default Footer
